<template>
  <div class='p-postEditor__itemAddBtnGroup'>
    <v-btn
      v-if='previousIndex != null'
      small
      tile
      style='border: 1px solid #c4c4c4'
      @click='switchItemAddBtn'
    >
      <v-icon left small> mdi-plus</v-icon>
      ここにアイテムを追加
    </v-btn>
    <template v-if='showItemAddBtn || previousIndex == null'>
      <item-add-btn
        variety='heading'
        variety-name='見出し'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='text'
        variety-name='本文'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='image'
        variety-name='画像'
        mdi-icon='mdi-image-area'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='point'
        variety-name='ポイント'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='external_link'
        variety-name='外部リンク'
        mdi-icon='mdi-link'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        type='button'
        :options='{}'
        variety-name='ボタン'
        variety='button'
        :previous-index='previousIndex'
      />
      <item-add-btn
        type='button'
        :options='{}'
        variety-name='バナー'
        variety='banner'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='internal_link'
        variety-name='関連記事'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='list'
        variety-name='リスト'
        mdi-icon='mdi-format-list-bulleted'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='quotation'
        variety-name='引用'
        mdi-icon='mdi-format-quote-close'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='embedding'
        variety-name='埋込み'
        mdi-icon='mdi-youtube'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='html'
        variety-name='埋込み'
        mdi-icon='mdi-instagram'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='embedding'
        variety-name='埋込み'
        mdi-icon='mdi-twitter'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='product_introduction'
        variety-name='商品紹介'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='character'
        variety-name='キャラクター'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
      />
      <item-add-btn
        variety='html'
        variety-name='埋め込み'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
        class='mb-5'
      />
      <item-add-btn
        variety='html_table'
        variety-name='表'
        type='button'
        :options='{}'
        :previous-index='previousIndex'
        class='mb-5'
      />
    </template>
  </div>
</template>

<script>
import ItemAddBtn from './ItemAddBtn'

export default {
  name: 'ItemAddBtnGroup',
  components: {
    ItemAddBtn
  },
  props: {
    previousIndex: {
      type: Number,
      required: false,
      default: null
    }
  },
  data () {
    return {
      showItemAddBtn: false
    }
  },
  methods: {
    switchItemAddBtn () {
      if (this.showItemAddBtn) {
        this.showItemAddBtn = false
      } else {
        this.showItemAddBtn = true
      }
    }
  }
}
</script>

<style scoped>
.p-postEditor__itemAddBtnGroup {
  padding: 5px;
  display: flex;
  flex-wrap: wrap;
}
</style>
